// @flow
import styled from 'styled-components';
import { cleanWhite, jetBlack } from '../colors';
var DefaultTheme = {
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "sc-1pjwmel-0"
  })(["visibility:", ";padding:0.5rem 1rem;background:", ";border:1px solid grey;position:absolute;", ""], function (props) {
    return props.visible ? 'visible' : 'hidden';
  }, cleanWhite(), function (props) {
    return typeof props.top === 'number' ? "top: " + props.top + "px;" : null;
  }),
  Background: styled.div.withConfig({
    displayName: "theme__Background",
    componentId: "sc-1pjwmel-1"
  })(["display:", ";position:fixed;z-index:10;left:0;top:0;width:100%;height:100%;background-color:", ";"], function (props) {
    return props.visible ? 'block' : 'none';
  }, jetBlack(0.75))
};
export default DefaultTheme;